export default "__VITE_ASSET__BnoTavtV__"